export default __webpack_public_path__ + "static/media/car-showcase.1943e741.png";